module.exports = __webpack_public_path__ + "static/img/アセット 30@2x.ea5f4f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 30@2x.png
// module id = mmuu
// module chunks = 1